import type { ReactElement } from 'react';

import ArrowRightLine from '@/assets/icons/arrow_right_line.svg?component';
import TrendingDownFill from '@/assets/icons/trending_down_fill.svg?component';
import TrendingUpFill from '@/assets/icons/trending_up_fill.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

export enum TrendIconEnum {
    TrendNone = 0,
    TrendPositiveUp = 1,
    TrendNegativeUp = 2,
    TrendPositiveDown = 3,
    TrendNegativeDown = 4,
    TrendStable = 5,
}

export const renderTrendIcon = (trend: TrendIconEnum, reverseColor = false): ReactElement => {
    const green = 'var(--tint-ocean-green-fg)';
    const red = 'var(--tint-red-fg)';
    const gray = 'var(--color-text-muted)';

    const positiveColor = reverseColor ? red : green;
    const negativeColor = reverseColor ? green : red;

    switch (trend) {
        case TrendIconEnum.TrendNone:
            return <></>;
        case TrendIconEnum.TrendPositiveUp:
            return (
                <SvgIcon
                    icon={TrendingUpFill}
                    size="custom"
                    customSize={20}
                    color={positiveColor}
                />
            );
        case TrendIconEnum.TrendPositiveDown:
            return (
                <SvgIcon
                    icon={TrendingDownFill}
                    size="custom"
                    customSize={20}
                    color={positiveColor}
                />
            );
        case TrendIconEnum.TrendNegativeUp:
            return (
                <SvgIcon
                    icon={TrendingUpFill}
                    size="custom"
                    customSize={20}
                    color={negativeColor}
                />
            );
        case TrendIconEnum.TrendNegativeDown:
            return (
                <SvgIcon
                    icon={TrendingDownFill}
                    size="custom"
                    customSize={20}
                    color={negativeColor}
                />
            );
        case TrendIconEnum.TrendStable:
            return <SvgIcon icon={ArrowRightLine} size="custom" customSize={20} color={gray} />;
    }
};
